import Loading from '../Loading';

const LoadingPageContent = () => {
  return (
    <div className="h-3/4 flex items-center justify-center">
      <Loading />
    </div>
  );
};

export default LoadingPageContent;
